import { render, staticRenderFns } from "./QuestionCategory.vue?vue&type=template&id=0e0deddd&"
import script from "./QuestionCategory.vue?vue&type=script&lang=js&"
export * from "./QuestionCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports